import { 
    apiRequest,
    koreksiKehadiranList,
    koreksiKehadiranInactive,
    EmployeeDetail
} from '../../../../../../services/adapters/kepegawaian/koreksiKehadiranService'

class IndexRepository {

    fetchEmployeeDetail = async (query, cancelToken) => {
        return await apiRequest("get", EmployeeDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", koreksiKehadiranList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", koreksiKehadiranInactive, {
            body: query
        }, true)
    }

}

export default IndexRepository